import { InputText } from "primereact/inputtext";
import { Select } from "../../../components";

export default function MarketingCampaignSendFiltersHeader({
  marketingsCampaigns,
  setSelectedMarketingCampaign,
  filters,
  size,
  handleInputFilterChange,
}) {
  const checkIfIncludes = (origin, text) => {
    if (!origin || !text) return false;
    return origin
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .includes(
        text
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase(),
      );
  };

  return (
    <div className="LayoutMarketingCampaigns__contain__children__campaignSelect">
      <Select
        label="Campañas de marketing"
        list={marketingsCampaigns?.sort((a, b) => {
          if (a.createdAt < b.createdAt) {
            return 1;
          } else return -1;
        })}
        fields={{ groupBy: "", text: "title", value: "_id" }}
        filter={(e) => {
          const searchData = marketingsCampaigns.filter((campaign) => {
            if (
              checkIfIncludes(campaign.title, e.text) ||
              checkIfIncludes(campaign.description, e.text)
            )
              return campaign;
          });
          if (searchData.length !== 0) e.updateData(searchData);
          else e.updateData([]);
        }}
        fn={(ev) => {
          const selectedCampaign = marketingsCampaigns.filter(
            (campaig) => campaig._id === ev.target.value,
          );
          setSelectedMarketingCampaign(selectedCampaign);
        }}
        defaultName={"Seleccione una campaña"}
      />
      <div
        className="LayoutMarketingCampaigns__contain__children__campaignSelect__search"
        style={
          size < 425
            ? {
                display: "flex",
                width: "90vw",
                justifyContent: "space-between",
              }
            : { display: "flex" }
        }
      >
        <div className="p-input-icon-left">
          <InputText
            id="search"
            value={filters.global.value || ""} // Bind value to filter state
            onChange={handleInputFilterChange}
            placeholder="Buscar en esta lista"
            style={
              size > 425
                ? { width: "30rem", marginRight: "1vw" }
                : { width: "20rem" }
            }
          />
        </div>
      </div>
    </div>
  );
}
